import { FormularioService } from './../../services/formulario.service';
import { NotificationService } from './../../services/notification.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { CabecalhoDTO } from 'src/app/entity/dto/cabecalho.component';
import { GeneralService } from 'src/app/services/general.service';
import { Make745CardIComponent } from './partialViews/make745-card-I.component';
import { ActivatedRoute } from '@angular/router';
import { EnumFormType } from 'src/app/entity/enum/enum-form-type';
import { BehaviorSubject } from 'rxjs';
import { EnumForm } from 'src/app/entity/enum/enum-form';
import { take } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { FormModalConfirmComponent } from 'src/app/shared/form-modal-confirm/form-modal-confirm.component';
import { ResumeAllFormsService } from 'src/app/services/resume-all-forms.service';
import { Make745CardIIComponent } from './partialViews/make745-card-II.component';
import { FormMake745 } from 'src/app/entity/forms/form-make745';
import * as moment from 'moment';

@Component({
  selector: 'app-form-make745',
  templateUrl: './form-make745.component.html'
})

export class FormMake745Component implements OnInit, AfterViewInit {
  public areaSelect: string = localStorage.getItem('area-select') || null;
  public header?: CabecalhoDTO;
  public formulario?: FormGroup;
  public btnCollapse?: boolean;
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public enableButtons = this.loadingSubject.asObservable();
  public showButtonSync = false;
  public formMake745: FormMake745 = new FormMake745();
  valuesInitial: any;
  valoresAlterados: any[] = [];
  currentUser: string = "";

  @ViewChild(Make745CardIComponent, { static: false }) make745CardIComponent: Make745CardIComponent;
  @ViewChild(Make745CardIIComponent, { static: false }) make745CardIIComponent: Make745CardIIComponent;

  // tslint:disable-next-line: max-line-length
  constructor(protected formBuilder: FormBuilder, protected generalService: GeneralService, protected notificationService: NotificationService, protected formularioService: FormularioService, protected route: ActivatedRoute, protected resumeAllFormsService: ResumeAllFormsService, public dialog: MatDialog) {
    this.formulario = this.formMake745.CreateForm(formBuilder);
  }

  ngAfterViewInit(): void {
    this.route.data.subscribe(async (data: any) => {
      if (!!data) {
        this.valuesInitial = data?.formulario ?? this.formulario.getRawValue();;
        const type = (this.route?.snapshot?.params?.type);
        const isReadOnly: boolean = type === '2' ? true : false;
        this.loadingSubject.next(isReadOnly ? false : true);
        if (type === '1' || type === '2') {
          if (type === '1') {
            this.header = this.generalService.createHeader(EnumForm.FormCPBMAKE000745, EnumFormType.Edit);
          } else {
            this.header = this.generalService.createHeader(EnumForm.FormCPBMAKE000745, EnumFormType.Details);
          }
          if (data.formulario.offline) {
            this.showButtonSync = true;
          }
          this.updateForm(data);
        } else {

          await this.getUser();
          this.fillCreatedByFormField();
          this.header = this.generalService.createHeader(EnumForm.FormCPBMAKE000745, EnumFormType.New);
          this.make745CardIComponent.formulario.get('centro_ensaque').setValue(this.generalService.getCentroEnsaqueByLocalStorageDataSite());
        }
      }
    });
  }


  ngOnInit(): void {
    // tslint:disable-next-line: max-line-length
    this.header = this.generalService.createHeader(EnumForm.FormCPBMAKE000745, EnumFormType.New);
    this.btnCollapse = true;
    this.loadingSubject.next(false);
  }

  async save(): Promise<void> {
    const id: number = this.formulario.get('id').value as number ?? 0;
    const isAddFlow = id === 0;
    if (this.validFormsToSave() === '') {
      this.buildFormulario();
      this.formulario.get('origem_negocio').setValue(String(this.generalService.areaSelect));
      await this.resumeAllFormsService.compareAdd(this.valuesInitial, this.formulario.getRawValue(), isAddFlow, 'ensaque_cs_0745');
      this.openConfirmDialog(this.resumeAllFormsService.valoresAlterados, isAddFlow);
    }
  }



  public openConfirmDialog(valoresAlterados: any[], isAddFlow): void {
    const values: any[] = valoresAlterados;
    const dialogRef = this.dialog.open(FormModalConfirmComponent, {
      data: {
        valoresAlterados: values,
        isAddFlow
      }
    });
    dialogRef.afterClosed().subscribe(x => {
      if (x.save) {
        const id: number = this.formulario.get('id').value as number;
        this.formularioService.saveForm(id, this.formulario.getRawValue(), 'ensaque_cs_0745', 'formmake745');
      }
      else {
        this.resumeAllFormsService.valoresAlterados = [];
      }
    })
  }

  getForms(): FormGroup[] {
    const arrForms: Array<FormGroup> = new Array<FormGroup>();
    arrForms.push(this.make745CardIComponent.formulario);
    arrForms.push(this.make745CardIIComponent.formulario);
    return arrForms;
  }

  validFormsToSave(): string {
    return this.formularioService.validForm(this.getForms());
  }

  cleanAll(): void {
    this.formularioService.cleanForm(this.getForms());
    this.make745CardIComponent.formulario.get('centro_ensaque').setValue(this.generalService.getCentroEnsaqueByLocalStorageDataSite());

  }


  collapseAll(): void {
    this.btnCollapse = this.btnCollapse ? false : true;
    this.make745CardIComponent.collapseCard = this.btnCollapse ? false : true;
    this.make745CardIIComponent.collapseCard = this.btnCollapse ? false : true;
  }

  public buildFormulario(): void {
    this.formulario = this.formMake745.buildForm(this.formulario, this.getForms(), this.generalService);
  }

  private updateForm(data?: any): void {
    this.formulario.get('id').setValue(data.formulario.id);
    if (data.formulario.hasOwnProperty('offline')) {
      this.formulario.get('offline').setValue(true);
    }
    this.formMake745.updateForm(data, this.getForms(), this.generalService);
  }


  private async getUser(): Promise<void> {
    await this.formularioService.getUser().pipe(take(1)).toPromise().then(response => {
      this.currentUser = response['user-profile']?.displayName ?? 'Administrador';
    }).catch(async error => {
      await this.generalService.getUserNameValue().pipe(take(1)).toPromise().then((response: string) => {
        this.currentUser = response;
      }).catch(err => {
      });
    });
  }

  public makeCalculations(event?: any): void {
    this.make745CardIComponent.formulario.get("estimativa_pa").setValue(this.make745CardIComponent.formulario?.get("peso_total_lote_kg").value / this.make745CardIComponent.formulario?.get("peso_sessenta_mil_sementes_impressao_kg").value)
  }


  public validDateSecondForm(event?: any): void {
    if (moment(this.make745CardIIComponent.formulario?.controls['data_conferencia_fisica'].value, "DD/MM/YYYY") < moment(this.make745CardIComponent.formulario?.controls['data_ensaque'].value, "DD/MM/YYYY"))
      this.make745CardIIComponent.formulario?.controls['data_conferencia_fisica'].setErrors({ 'dateHighThanActual': true });
    else if (moment(this.make745CardIIComponent.formulario?.controls['data_conferencia_fisica'].value, "DD/MM/YYYY") >= moment(this.make745CardIComponent.formulario?.controls['data_ensaque'].value, "DD/MM/YYYY"))
      this.make745CardIIComponent.formulario?.controls['data_conferencia_fisica'].setErrors(null);

    if (moment(this.make745CardIIComponent.formulario?.controls['data_hora_apontamento'].value, "DD/MM/YYYY") < moment(this.make745CardIComponent.formulario?.controls['data_ensaque'].value, "DD/MM/YYYY"))
      this.make745CardIIComponent.formulario?.controls['data_hora_apontamento'].setErrors({ 'dateHighThanActual': true });
    else if (moment(this.make745CardIIComponent.formulario?.controls['data_hora_apontamento'].value, "DD/MM/YYYY") >= moment(this.make745CardIComponent.formulario?.controls['data_ensaque'].value, "DD/MM/YYYY"))
      this.make745CardIIComponent.formulario?.controls['data_hora_apontamento'].setErrors(null);

  }

  private fillCreatedByFormField(): void {
    this.make745CardIIComponent.formulario.get('criado_por').setValue(this.currentUser);
  }
}



